function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0-erl{fill:#FFFFFF;}\r\n\t.st1-erl{fill:#A90533;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1_"
}, /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_2_",
  x: 67.5,
  y: 89.6,
  className: "st0-erl",
  width: 365,
  height: 320.8
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_3_",
  className: "st1-erl",
  d: "M130.7,317.2c-26.8-28.4-42.5-67.7-42.5-114.5c0-41.4,13-77,35.3-104.1l0,0h-47v218.6 L130.7,317.2L130.7,317.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_4_",
  className: "st1-erl",
  d: "M378.3,317.3c11.5-12.4,21.9-26.9,31.3-43.6l-52-26c-18.3,29.7-45,57.1-82,57.2 c-53.8-0.2-74.9-46.2-74.8-105.4h201c0.3-6.7,0.3-9.8,0-13c1.3-35.2-8-64.8-25-87.9l-0.1,0.1H422v218.6L378.3,317.3L378.3,317.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_5_",
  className: "st1-erl",
  d: "M204.1,148.8c2.2-26.8,23.4-44.8,48.1-44.9c24.9,0.1,43,18.1,43.6,44.9H204.1z"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_6_",
  points: "105.2,354.3 105.2,345.2 77.2,345.2 77.2,399.2 105.2,399.2 105.2,390.1 87.6,390.1 87.6,375.8  104.5,375.8 104.5,366.7 87.6,366.7 87.6,354.3  "
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_7_",
  d: "M152.7,376.4c7-1,10.8-7.9,11.1-15c-0.3-11.5-7.7-16.2-18.2-16.3h-14.3v54h10.4v-21.5l13,21.5h13 L152.7,376.4z M141.6,353.7h1.3c5.7,0.2,9.9,1.5,9.8,8.5c0.2,6.4-3.9,8.1-9.8,7.8h-1.3V353.7z"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_10_",
  points: "200.1,345.2 189.7,345.2 189.7,399.2 215.1,399.2 215.1,390.1 200.1,390.1  "
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_11_",
  d: "M268.5,388.1l4.6,11.1h11.1l-20.2-55.3h-8.5L234,399.2H245l4.6-11.1H268.5z M265.8,379.7h-13l5.9-20.2 L265.8,379.7z"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_14_",
  points: "303.6,399.2 314.6,399.2 314.6,362.8 343.3,400.5 351.1,400.5 351.1,345.2 340,345.2 340,381.6  311.4,343.9 303.6,343.9  "
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_15_",
  d: "M396.6,370.6v8.5h11.7c-0.2,6.8-5.8,12.6-12.4,12.4c-10.4,0.2-15.5-9.8-15.6-18.9 c0.1-8.9,5.2-19.4,15.6-19.5c5.5,0.1,10.1,3.9,12.4,8.5l9.1-4.6c-4-8.4-12.1-13.1-21.5-13c-16.1-0.1-26.5,13.2-26.7,28.6 c0.2,15,10.3,28.4,26,28.6c17-0.2,24.9-13.8,24.7-29.3v-1.3H396.6z"
}));

const SvgErlang01 = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgErlang01, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Erlang-01.0aedf6b6.svg";
export { ForwardRef as ReactComponent };